export default __webpack_public_path__ + "static/media/alimentacao.36e0f0fb.png";